

export function createCoinElement(coin, selectedOrAvailable: 'selected' | 'available', enabled = true, onClick) {
    const coinDiv = document.createElement('div');
    coinDiv.className = selectedOrAvailable == 'selected' ? 'coin-item' : 'available-coin-item';
    
    const img = document.createElement('img');
    img.src = `/icons/${coin.imageName}`;
    img.alt = coin.name;
    img.loading = 'lazy';
    
    const name = document.createTextNode(coin.name);
    coinDiv.appendChild(img);
    coinDiv.appendChild(name);
    
    const button = document.createElement('button');
    button.className = selectedOrAvailable == 'selected' ? 'remove-coin' : 'add-coin';
    button.innerHTML = selectedOrAvailable == 'selected' ? '×' : '+';
    button.setAttribute('aria-label', selectedOrAvailable == 'selected' ?  `Remove ${coin.name}`: `Add ${coin.name}`);

    if (!enabled) {
        button.disabled = true;
        coinDiv.classList.add('disabled');
    }

    coinDiv.addEventListener('click', () => {
        onClick(coin.id);
    });

    coinDiv.appendChild(button);
    return coinDiv;
}
